var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16.7725C2.14327 15.8643 1.25 14.3177 1.25 12.5625C1.25 9.92598 3.26545 7.7602 5.83971 7.52179C6.36629 4.31865 9.14777 1.875 12.5 1.875C15.8522 1.875 18.6337 4.31865 19.1603 7.52179C21.7346 7.7602 23.75 9.92598 23.75 12.5625C23.75 14.3177 22.8567 15.8643 21.5 16.7725M8 17.625L12.5 22.125M12.5 22.125L17 17.625M12.5 22.125V12",
    stroke: "#224A91",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.f1fda3ae7978a69ccba9e541a981186e.svg";
export { ForwardRef as ReactComponent };